<template>
  <div class="container-popups-simples-form">
    <template v-if="internal_config">
      <sweet-modal
        ref="config"
        width="50vw">
        <sweet-modal-tab
          id="email"
          :title="this.$t('ct-email')">
          <div class="form-group">
            <label for="simple-form-email">{{ $t('ct-email-receiver') }}</label>
            <input
              id="simple-form-email"
              :class="{ 'is-invalid': errors.has('receiver')}"
              v-model="internal_config.receiver"
              type="email"
              placeholder="example@example.com"
              class="form-control"
              @change="validateEmail"
              @keydown="errors.clear('receiver')">
            <span
              v-if="errors.has('receiver')"
              class="invalid-feedback"
              v-text="errors.get('receiver')"
            />
          </div>

          <div class="form-group">
            <label for="simple-form-subject">{{ $t('ct-subject') }}</label>
            <input
              id="simple-form-subject"
              :placeholder="$t('ct-subject')"
              v-model="internal_config.subject"
              type="text"
              class="form-control">
          </div>

          <div class="form-group">
            <label for="simple-form-redirect">{{ $t('ct-redirect-url') }}</label>
            <input
              id="simple-form-redirect"
              :placeholder="$t('ct-redirect')"
              v-model="internal_config.redirect"
              type="url"
              class="form-control">
          </div>

          <p class="my-3">{{ $t('ct-success-message-and-errors') }}</p>

          <div class="form-group">
            <label for="simple-form-successMessage">{{ $t('ct-success-message') }}</label>
            <input
              id="simple-form-successMessage"
              v-model="internal_config.successMessage"
              type="text"
              class="form-control">
          </div>

          <div class="form-group">
            <label for="simple-form-isRequiredMessage">{{ $t('ct-is-required-message') }}</label>
            <input
              id="simple-form-isRequiredMessage"
              v-model="internal_config.isRequiredMessage"
              type="text"
              class="form-control">
          </div>
        </sweet-modal-tab>

        <sweet-modal-tab
          id="groups"
          :title="this.$t('ct-groups')">
          <div
            class="configuration-group-multi-step"
            style="padding-top: 50px">

            <button
              class="btn btn-primary float-right text-uppercase"
              style="margin-top: -50px;"
              @click="addGroup()">
              <font-awesome-icon
                :icon="['fas', 'plus-circle']"
                class="font-awesome-icon mr-2"/>
              {{ $t('ct-add-group') }}
            </button>

            <template
              v-for="(group,indexGroup) in internal_config.groups"
              class="accordion-settings">

              <cc-collapse
                :class="'collapse-settings-fields-multi-step'"
                :title="group.name">
                <template v-slot:headerOptions v-if="internal_config.groups.length > 2">
                  <font-awesome-icon
                    @click.stop="removeGroup(indexGroup)"
                    :icon="['fas', 'trash']"
                    class="font-awesome-icon sort-icon"
                  />
                </template>
                <div>
                  <label>{{ $t('ct-group-name') }}</label>
                  <div class="form-group">
                    <input
                      :id="'group-name-action'+indexGroup"
                      v-model="group.name"
                      type="url"
                      :placeholder="$t('ct-group-name')"
                      class="form-control">
                  </div>
                  <label>{{ $t('ct-group-description') }}</label>
                  <div class="form-group">
                    <input
                      :id="'group-description-action'+indexGroup"
                      v-model="group.description"
                      type="url"
                      :placeholder="$t('ct-group-icon')"
                      class="form-control">
                  </div>
                  <label>{{ $t('ct-group-icon') }}</label>
                  <div
                    class="form-group"
                    style="display: flex">
                    <div
                      class="icon-settings-content-align"
                      style="margin-right: 15px">
                      <div class="btn-icon-group">
                        <div class="btn-icon-align">
                          <i :class="['mdi', group.icon]"/>
                        </div>
                      </div>
                    </div>
                    <button
                      v-if="group.icon !== ''"
                      slot="button"
                      class="btn btn-primary ml-0 float-left"
                      @click="selectGroupIcon(indexGroup)"><i
                      class="svg-icon svgi-add-page"/>{{ $t('ct-change-icon') }}
                    </button>
                    <button
                      v-else
                      slot="button"
                      class="btn btn-primary ml-0 float-left"
                      @click="selectGroupIcon(indexGroup)"><i
                      class="svg-icon svgi-add-page"/>{{ $t('ct-add-icon') }}
                    </button>
                    <button
                      class="btn btn-danger btn-lg px-4"
                      @click="removeGroupIcon(indexGroup)"
                    >
                      <i
                        v-tooltip="{content:$t('ct-option-delete'), class: 'tooltip-custom'}"
                        class="svg-icon svgi-delete svgi-light m-0"/>
                    </button>
                  </div>

                  <label>{{ $t('ct-group-fields') }}</label>
                  <table class="table">
                    <thead>
                      <th scope="col">{{ $t('ct-type') }}</th>
                      <th scope="col">{{ $t('ct-label') }}</th>
                      <th scope="col">{{ $t('ct-tag') }}</th>
                      <th scope="col">
                        <button
                          class="btn btn-primary float-right text-uppercase"
                          @click="addFieldAtGroup(indexGroup)">
                          <font-awesome-icon
                            :icon="['fas', 'plus-circle']"
                            class="font-awesome-icon mr-2"/>
                          {{ $t('ct-add-field') }}
                        </button>
                      </th>
                    </thead>
                    <tbody>
                      <template v-if="group.fields.length">
                        <tr
                          v-for="(field,index) in group.fields"
                          :class="{'animated flash': internal_config.fieldAnimated}"
                          @animationend="internal_config.fieldAnimated = false"
                        >
                          <td>{{ field.field }}</td>
                          <td>{{ field.label }}</td>
                          <td>{{ field.tag }}</td>
                          <td class="text-right">

                            <i
                              v-tooltip="{content:$t('ct-option-down'), class: 'tooltip-custom'}"
                              class="mdi mdi-chevron-down text-secondary"
                              @click="changePosition(indexGroup, index, index+1)"
                            />

                            <i
                              v-tooltip="{content:$t('ct-option-up'), class: 'tooltip-custom'}"
                              class="mdi mdi-chevron-up text-secondary"
                              @click="changePosition(indexGroup, index, index-1)"
                            />

                            <i
                              v-tooltip="{content:$t('ct-option-edit'), class: 'tooltip-custom'}"
                              class="mdi mdi-pencil text-primary"
                              @click="editField(field, index)"
                            />

                            <i
                              v-tooltip="{content:$t('ct-option-delete'), class: 'tooltip-custom'}"
                              class="ct-icon-trash text-danger"
                              @click.prevent="removeOption(index, 0, indexGroup)"
                            />
                          </td>
                        </tr>
                      </template>
                      <tr v-else>
                        <td
                          colspan="4"
                          class="text-center">
                          {{ $t('ct-fields-empty') }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </cc-collapse>

            </template>
          </div>
          <small class="text-for-help">{{ $t('ct-hint-email-reply-to') }}</small>
        </sweet-modal-tab>

        <sweet-modal-tab
          id="action"
          :title="this.$t('ct-action')">
          <div class="form-group">
            <label for="simple-form-action">{{ $t('ct-action-url') }}</label>
            <input
              id="simple-form-action"
              v-model="internal_config.action"
              type="url"
              :placeholder="$t('ct-action-url')"
              class="form-control">
            <small class="text-for-help">
              <a
                :href="`${this.officeUrl}/us/office/franchise-system?opentool=linkMagicFunnel`"
                target="_blank">{{ $t('ct-link-magic-funnel-link') }}</a>
              {{ $t('ct-link-magic-funnel') }}
            </small>
          </div>
        </sweet-modal-tab>

        <button
          slot="button"
          class="btn btn-outline-light"
          @click="close('config')"
        >{{ $t('ct-cancel') }}
        </button>
        <button
          slot="button"
          class="btn btn-success"
          @click="save"><i
          class="svg-icon svgi-save"/>{{ $t('ct-save') }}
        </button>
      </sweet-modal>

      <sweet-modal
        ref="addField"
        :title="$t('ct-add-field')"
        width="600px">
        <div class="container-field-add">
          <button
            type="button"
            class="btn btn-primary"
            @click="openPopupField('text', 'text')">
            <font-awesome-icon
              :icon="['fas', 'plus-circle']"
              class="font-awesome-icon mr-2"/>
            {{ $t('ct-input-text') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="openPopupField('text', 'textarea')">
            <font-awesome-icon
              :icon="['fas', 'plus-circle']"
              class="font-awesome-icon mr-2"/>
            {{ $t('ct-input-textarea') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="openPopupField('text', 'password')">
            <font-awesome-icon
              :icon="['fas', 'plus-circle']"
              class="font-awesome-icon mr-2"/>
            {{ $t('ct-input-password') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="openPopupField('select', 'checkbox')">
            <font-awesome-icon
              :icon="['fas', 'plus-circle']"
              class="font-awesome-icon mr-2"/>
            {{ $t('ct-input-checkbox') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="openPopupField('select', 'radio')">
            <font-awesome-icon
              :icon="['fas', 'plus-circle']"
              class="font-awesome-icon mr-2"/>
            {{ $t('ct-input-radio') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="openPopupField('select', 'select')">
            <font-awesome-icon
              :icon="['fas', 'plus-circle']"
              class="font-awesome-icon mr-2"/>
            {{ $t('ct-input-select') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="openPopupField('text', 'date')">
            <font-awesome-icon
              :icon="['fas', 'plus-circle']"
              class="font-awesome-icon mr-2"/>
            {{ $t('ct-input-date') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="openPopupField('text', 'datetime')">
            <font-awesome-icon
              :icon="['fas', 'plus-circle']"
              class="font-awesome-icon mr-2"/>
            {{ $t('ct-input-datetime') }}
          </button>
        </div>
        <button
          slot="button"
          class="btn btn-outline-light"
          @click="close('addField')">{{ $t('ct-cancel') }}
        </button>
      </sweet-modal>

      <sweet-modal
        ref="addGroup"
        :title="$t('ct-add-group')"
        width="600px">
        <div class="container-group-add">
          <label>{{ $t('ct-group-name') }}</label>
          <div class="form-group">
            <input
              v-model="newGroupName"
              type="url"
              :placeholder="$t('ct-group-name')"
              class="form-control">
          </div>
          <label>{{ $t('ct-group-description') }}</label>
          <div class="form-group">
            <input
              v-model="newGroupDescription"
              type="url"
              :placeholder="$t('ct-group-description')"
              class="form-control">
          </div>
        </div>
        <button
          slot="button"
          class="btn btn-outline-light"
          @click="close('addGroup')">{{ $t('ct-cancel') }}
        </button>
        <button
          slot="button"
          class="btn btn-success"
          @click="saveGroup()"><i
          class="svg-icon svgi-save"/>{{ $t('ct-save') }}
        </button>
      </sweet-modal>

      <sweet-modal
        ref="text"
        :title="$t('ct-config-field')"
        width="40vw">
        <div class="form-row">
          <div class="form-group col-12 col-sm-3">
            <label>{{ $t('ct-tag') }}</label>
            <input
              v-model="internal_config.newField.tag"
              :class="{ 'is-invalid': errors.has('newField.tag')}"
              type="text"
              class="form-control"
              name="tag"
              @keydown="errors.clear('newField.tag')">
            <span
              v-if="errors.has('newField.tag')"
              class="invalid-feedback"
              v-text="errors.get('newField.tag')"
            />
          </div>
          <div class="form-group col-12 col-sm-9">
            <label>{{ $t('ct-label') }}</label>
            <input
              v-model="internal_config.newField.label"
              :class="{ 'is-invalid': errors.has('newField.label')}"
              type="text"
              class="form-control"
              name="label"
              @keydown="errors.clear('newField.label')">
            <span
              v-if="errors.has('newField.label')"
              class="invalid-feedback"
              v-text="errors.get('newField.label')"
            />
          </div>

          <div class="form-group col-12 col-sm-5">
            <label>{{ $t('ct-default-value') }}</label>
            <input
              v-model="internal_config.newField.default_value"
              type="text"
              class="form-control"
              name="default_value">
          </div>

          <div class="form-group col-12 col-sm-7">
            <label>{{ $t('ct-help-text') }}</label>
            <input
              v-model="internal_config.newField.help_text"
              type="text"
              class="form-control"
              name="help_text">
          </div>

          <div class="form-group col-12 col-sm-5">
            <label>{{ $t('ct-required') }}</label>
            <select
              v-model="internal_config.newField.required"
              name="required"
              class="form-control"
              @change="verifyRequired">
              <option value="yes">{{ $t('ct-yes') }}</option>
              <option value="no">{{ $t('ct-no') }}</option>
            </select>
          </div>

          <div
            ref="visibilyField"
            class="form-group col-12 col-sm-7">
            <label>{{ $t('ct-visibility') }}</label>
            <select
              v-model="internal_config.newField.visibility"
              name="visibility"
              class="form-control">
              <option value="visible">{{ $t('ct-visible') }}</option>
              <option value="hidden">{{ $t('ct-hidden') }}</option>
            </select>
          </div>
          <div
            v-if="typeof internal_config.newField.icon != 'undefined' && internal_config.newField.icon.selected"
            class="form-group col-12 d-flex justify-content-between align-items-end">

            <div
              v-show="typeof internal_config.newField.icon != 'undefined' && internal_config.newField.icon && typeof internal_config.newField.icon.selected != 'undefined'"
              class="icon-settings-content-align flex-1">
              <div
                v-if="internal_config.newField.icon"
                class="form-group">
                <label class="text__simple-text"> {{ $t('ct-icon-settings') }} - {{ $t('ct-align') }}</label>
                <div class="btn-icon-group">
                  <div
                    :class="{'active' : typeof internal_config.newField.icon != 'undefined' && internal_config.newField.icon.position === 'left'}"
                    class="btn-icon-align"
                    @click.prevent="changeIconPosition('left')"
                  >
                    <i :class="['mdi', internal_config.newField.icon.selected]"/>
                    <span>{{ $t('ct-left') }}</span>
                    <i class="input-radio-icon"/>
                  </div>
                  <div
                    :class="{'active' : typeof internal_config.newField.icon != 'undefined' && internal_config.newField.icon.position === 'right'}"
                    class="btn-icon-align"
                    @click.prevent="changeIconPosition('right')"
                  >
                    <span>{{ $t('ct-right') }}</span>
                    <i :class="['mdi', internal_config.newField.icon.selected]"/>
                    <i class="input-radio-icon"/>
                  </div>
                </div>
              </div>
            </div>
            <button
              class="btn btn-danger btn-lg px-4"
              @click="removeIcon"
            >
              <i
                v-tooltip="{content:$t('ct-option-delete'), class: 'tooltip-custom'}"
                class="svg-icon svgi-delete svgi-light m-0"/>
            </button>
          </div>
        </div>

        <button
          v-if="typeof internal_config.newField.icon !== 'undefined' && internal_config.newField.icon.selected"
          slot="button"
          class="btn btn-primary ml-0 float-left"
          @click="selectIcon"><i class="svg-icon svgi-add-page"/>{{ $t('ct-change-icon') }}
        </button>
        <button
          v-else
          slot="button"
          class="btn btn-primary ml-0 float-left"
          @click="selectIcon"><i
          class="svg-icon svgi-add-page"/>{{ $t('ct-add-icon') }}
        </button>

        <button
          slot="button"
          class="btn btn-outline-light"
          @click="close('text')">{{ $t('ct-cancel') }}</button>
        <button
          slot="button"
          class="btn btn-success"
          @click="genField('text')"><i
          class="svg-icon svgi-save"/>{{ $t('ct-save') }}
        </button>
      </sweet-modal>

      <sweet-modal
        ref="select"
        :title="$t('ct-config-field')">
        <div class="form-row">
          <div class="form-group col-12 col-sm-3">
            <label>{{ $t('ct-tag') }}</label>
            <input
              v-model="internal_config.newField.tag"
              :class="{ 'is-invalid': errors.has('newField.tag')}"
              type="text"
              class="form-control"
              name="tag"
              @keydown="errors.clear('newField.tag')">
            <span
              v-if="errors.has('newField.tag')"
              class="invalid-feedback"
              v-text="errors.get('newField.tag')"
            />
          </div>
          <div class="form-group col-12 col-sm-9">
            <label>{{ $t('ct-label') }}</label>
            <input
              v-model="internal_config.newField.label"
              :class="{ 'is-invalid': errors.has('newField.label')}"
              type="text"
              class="form-control"
              name="label"
              @keydown="errors.clear('newField.label')">
            <span
              v-if="errors.has('newField.label')"
              class="invalid-feedback"
              v-text="errors.get('newField.label')"
            />
          </div>

          <div class="form-group col-12 col-sm-6">
            <label>{{ $t('ct-help-text') }}</label>
            <input
              v-model="internal_config.newField.help_text"
              type="text"
              class="form-control"
              name="help_text">
          </div>

          <div class="form-group col-12 col-sm-3">
            <label>{{ $t('ct-required') }}</label>
            <select
              v-model="internal_config.newField.required"
              name="required"
              class="form-control"
              @change="verifyRequired">
              <option value="yes">{{ $t('ct-yes') }}</option>
              <option value="no">{{ $t('ct-no') }}</option>
            </select>
          </div>

          <div
            ref="visibilyFieldOption"
            class="form-group col-12 col-sm-3">
            <label>{{ $t('ct-visibility') }}</label>
            <select
              v-model="internal_config.newField.visibility"
              name="visibility"
              class="form-control">
              <option value="visible">{{ $t('ct-visible') }}</option>
              <option value="hidden">{{ $t('ct-hidden') }}</option>
            </select>
          </div>
        </div>

        <span class="table-caption">{{ $t('ct-resource-components') }}</span>

        <div class="table-contact-form">
          <table class="table">
            <thead>
              <th>{{ $t('ct-value') }}</th>
              <th>{{ $t('ct-name') }}</th>
              <th class="text-center">{{ $t('ct-default-option') }}</th>
              <th class="text-right">
                <button
                  v-tooltip="{content:$t('ct-delete-default-value'), class: 'tooltip-custom'}"
                  v-if="internal_config.newField.default_value"
                  class="btn m-0 p-0"
                  @click="internal_config.newField.default_value = ''">
                  <i class="ct-icon-trash text-dark"/>
                </button>
                <button
                  class="btn btn-primary ml-1"
                  @click="openOptionPopup">
                  <font-awesome-icon
                    :icon="['fas', 'plus-circle']"
                    class="font-awesome-icon mr-2"/>
                  {{ $t('ct-add-option') }}
                </button>
              </th>
            </thead>
            <tbody>
              <template v-if="internal_config.newField.options.length">
                <tr v-for="(option,index) in internal_config.newField.options">
                  <td>{{ option.value }}</td>
                  <td>{{ option.name }}</td>
                  <td class="text-center">
                    <div class="form-check">
                      <input
                        :id="'defaultOption' + index"
                        :value="option.value"
                        v-model="internal_config.newField.default_value"
                        class="form-check-input position-static"
                        type="radio"
                        name="defaultOption">
                    </div>
                  </td>
                  <td class="text-right">
                    <i
                      v-tooltip="{content:$t('ct-option-delete'), class: 'tooltip-custom'}"
                      class="ct-icon-trash text-danger"
                      @click="removeOption(index,1, null)"
                    />
                  </td>
                </tr>
              </template>
              <tr v-else>
                <td
                  colspan="4"
                  class="text-center">
                  {{ $t('ct-options-empty') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <button
          slot="button"
          class="btn btn-outline-light"
          @click="close('select')">{{ $t('ct-cancel') }}</button>
        <button
          slot="button"
          class="btn btn-success"
          @click="genField('select')"><i
          class="svg-icon svgi-save"/>{{ $t('ct-save') }}
        </button>
      </sweet-modal>

      <sweet-modal
        ref="option"
        :title="$t('ct-config-field')"
        width="40vw">
        <div class="form-row">
          <div class="form-group col-4">
            <label>{{ $t('ct-value') }}</label>
            <input
              ref="form_option_value"
              type="text"
              class="form-control"
              name="value">
          </div>

          <div class="form-group col-8">
            <label>{{ $t('ct-name') }}</label>
            <input
              ref="form_option_name"
              type="text"
              class="form-control"
              name="name">
          </div>
        </div>

        <button
          slot="button"
          class="btn btn-outline-light"
          @click="close('option')">{{ $t('ct-cancel') }}</button>
        <button
          slot="button"
          class="btn btn-success"
          @click="addOption"><i
          class="svg-icon svgi-save"/>{{ $t('ct-save') }}
        </button>
      </sweet-modal>
    </template>
  </div>
</template>

<script>

import {SweetModal, SweetModalTab} from 'sweet-modal-vue';
import CheckFields from '../Fields/CheckFields';
import SelectFields from '../Fields/SelectFields';
import TextFields from '../Fields/Text';
import DateFields from '../Fields/DateFields';
import Errors from "../../../../../js/base/Errors";

export default {
  name: 'ConfigModals',
  components: {
    SweetModal,
    SweetModalTab,
    CheckFields,
    SelectFields,
    TextFields,
    DateFields
  },
  data() {
    return {
      current_group: 0,
      newGroupName: '',
      newGroupDescription: '',
      internal_config: false,
      config_current: {
        internal: false,
        field: false,
      },
      callback: false,
      errors: new Errors()
    };
  },
  computed: {
    officeUrl() {
      return typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : "https://office.builderall.com"
    }
  },
  methods: {
    init(config, callback = false) {
      this.internal_config = config;
      this.callback = callback;
    },
    open(modal) {
      if (modal === 'config')
        this.config_current['internal'] = JSON.parse(JSON.stringify(this.internal_config));


      if (this.$refs[modal])
        this.$refs[modal].open();

    },

    close(modal) {

      if (modal === 'config') {
        this.callback(this.config_current['internal']);
        this.reload();
      }

      if (modal === 'text' || modal === 'select') {
        var field = {...this.config_current['field']};
        delete field.index;
        this.internal_config.fields[this.config_current['field'].index] = {...field};
      }

      if (this.callback && typeof this.callback === 'function')
        this.$refs[modal].close();


      this.errors.clear();
    },

    save() {

      if (!this.validate())
        return;


      if (this.callback && typeof this.callback === 'function') {
        this.callback(this.internal_config);
        this.$refs['config'].close();
      }
    },

    validate() {

      if (this.errors.any()) {
        this.$snotify.warning(this.$t('ct-check-configs'));
        return false;
      }

      if (this.internal_config.receiver.length === 0 && this.internal_config.action.length === 0) {
        this.$snotify.warning(this.$t('ct-config-action-receiver'));

        return false;
      } else if (this.internal_config.receiver.length > 0 && this.internal_config.action.length === 0)
        this.validateEmail();


      return true;
    },

    validateEmail() {
      let regexEmail = new RegExp(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);

      if (this.internal_config.receiver.length === 0)
        this.errors.add('receiver', 'validation-required');


      if (this.internal_config.receiver.length > 0 && !regexEmail.exec(this.internal_config.receiver))
        this.errors.add('receiver', 'invalid-email-regex');


    },

    editField(field, index) {
      this.internal_config.newField = field;

      this.internal_config.newField.status = 'edit';

      if (typeof field.icon === 'undefined')
        this.internal_config.newField.icon = {'selected': null, 'position': null};


      this.verifyRequired();

      this.config_current['field'] = {...field, index: index};

      if (
        this.internal_config.newField.field === 'datetime' ||
        this.internal_config.newField.field === 'date' ||
        this.internal_config.newField.field === 'text' ||
        this.internal_config.newField.field === 'textarea'
      )
        this.$refs['text'].open();
       else
        this.$refs['select'].open();

    },

    animateField() {
      this.internal_config.fieldAnimated = true;
    },
    addFieldAtGroup(index) {
      this.current_group = index;
      this.$refs.addField.open();
    },
    addGroup() {
      this.$refs.addGroup.open();
    },

    removeGroup(index) {
      this.internal_config.groups.splice(index, 1);
      this.reloadConfig();
    },

    saveGroup() {

      this.internal_config.groups[this.internal_config.groups.length] = {
        name: this.newGroupName,
        description: this.newGroupDescription,
        icon: '',
        fields: []
      };
      this.reloadConfig();
      this.$refs.addGroup.close();
      this.newGroupName = '';
      this.newGroupDescription = ''
    },

    changePosition(groupIndex, index, newIndex) {
      if (newIndex >= this.internal_config.groups[groupIndex].fields.length || newIndex < 0)
        return;


      this.animateField();
      this.internal_config.groups[groupIndex].fields.splice(
        newIndex,
        0,
        this.internal_config.groups[groupIndex].fields.splice(index, 1)[0]
      );
    },

    openOptionPopup() {
      this.$refs.form_option_name.value = '';
      this.$refs.form_option_value.value = '';
      this.$refs.option.open();
    },

    reloadConfig() {
      let config = this.internal_config;
      this.internal_config = Object.assign({}, this.internal_config, config);
    },

    selectIcon() {
      let _self = this;
      let selectIcon;

      window.vm.$root.$emit('showIconList', function(icon) {
        selectIcon = {'selected': icon, 'position': 'left'};
        _self.internal_config.newField.icon = selectIcon;

        let config = _self.internal_config;
        _self.internal_config = Object.assign({}, _self.internal_config, config);
      });
    },
    selectGroupIcon(index) {
      let _self = this;

      window.vm.$root.$emit('showIconList', function(icon) {
        _self.internal_config.groups[index].icon = icon;

        let config = _self.internal_config;
        _self.internal_config = Object.assign({}, _self.internal_config, config);
      });
    },
    removeIcon() {
      this.internal_config.newField.icon = {'selected': false, 'position': 'left'};
      this.reloadConfig();
    },
    removeGroupIcon(index) {
      this.internal_config.groups[index].icon = '';
      this.reloadConfig();
    },
    changeIconPosition(value) {
      this.internal_config.newField.icon.position = value;
      this.reloadConfig();
    },

    verifyRequired() {
      if (this.internal_config.newField.required == 'no') {
        this.$refs.visibilyField.style.display = 'block';
        this.$refs.visibilyFieldOption.style.display = 'block';
      } else {
        this.$refs.visibilyField.style.display = 'none';
        this.$refs.visibilyFieldOption.style.display = 'none';
      }
    },

    genField(val) {

      if (typeof this.internal_config.newField.tag === "undefined" || this.internal_config.newField.tag.length === 0)
        this.errors.add('tag', 'validation-required', 'newField');


      if (this.errors.any())
        return;

      if (this.internal_config.newField.status === 'add') {
        this.internal_config.groups[this.current_group].fields.push(
          Object.assign({}, this.internal_config.newField)
        );
      }
      this.$refs[val].close();
      this.$refs.addField.close();
    },

    reload() {
      let config = this.internal_config;
      this.internal_config = Object.assign({}, this.internal_config, config);
    },

    addOption() {
      let obj = {
        name: this.$refs.form_option_name.value,
        value: this.$refs.form_option_value.value
      };
      this.internal_config.newField.options.push(Object.assign({}, obj));
      this.$refs.option.close();

      this.reload();
    },

    removeOption(index, level, indexGroup) {
      if (level === 0)
        this.internal_config.groups[indexGroup].fields.splice(index, 1);
       else
        this.internal_config.newField.options.splice(index, 1);


      this.reload();
    },

    openPopupField(val, field) {
      this.internal_config.newField = false;
      this.internal_config.newField = {};

      this.internal_config.newField.status = 'add';
      this.internal_config.newField.field = field;
      this.internal_config.newField.label = '';
      this.internal_config.newField.default_value = '';
      this.internal_config.newField.visibility = 'visible';
      this.internal_config.newField.required = 'no';
      this.internal_config.newField.options = [];
      this.internal_config.newField.help_text = '';
      this.internal_config.newField.icon = {'selected': null, 'position': null};

      this.verifyRequired();

      this.$refs[val].open();
    }
  }
};
</script>

<style lang="scss">

.configuration-group-multi-step {

  .accordion-settings {
    margin-bottom: 15px;

    .alert-info,
    .text-center,
    form,
    label {
      font-family: "Muli";
      font-size: 0.80em;
    }

    .collapse {
      background-color: white;
      border: 1px solid lightgray !important;
    }

    .card-header {
      padding: 15px 10px !important;
      background: white;
      border: 1px solid lightgray !important;
      border-radius: 5px;
      margin-bottom: 0;

      h5 {
        font-family: "Muli";
        font-weight: bold;
        font-size: 0.75em;
        position: relative;
      }

      .dropdown-arrow::after {
        right: 10px;
        margin-top: 5px;
        color: #007ffc;
        font-size: 20px;
      }
    }

    .card-header[aria-expanded="true"] {
      background-color: white;
      border-radius: 0;
      margin-left: 0 !important;
      margin-right: 0 !important;
      position: relative;
    }
  }
}


</style>
<style lang="scss" scoped>

.card-header {
  padding: 25px 15px;
}

a.nav-link.settings-tab.active {
  background-color: #f9fafd !important
}

.personal-tab-content {
  .card {
    background-color: #f9fafd;
  }
}

.icon-settings-content-align {
  display: flex;

  &__selected {
    display: flex;
    flex-direction: column;
  }

  .form-group {
    margin-bottom: 0;
  }

  .form-group:last-child {
    flex: 1;
  }

  .btn-icon-group {
    display: flex;
    padding-top: 3px;

    .btn-icon-align {
      position: relative;
      flex: 1;
      background: #FAFBFC;
      border: 1px dashed #B0BFCE;
      border-radius: 5px;

      text-align: left;
      font-size: 14px;

      transition: .4s;

      padding: 10px 20px;

      &:hover, &.active, &:focus {
        border: 1px dashed #0080FC;
        outline: none;
      }

      i {
        margin: 0 5px;

        font-size: 18px;
        color: #0795ff;
      }

      .input-radio-icon {
        top: 8px;
        right: 5px;

        width: 15px;
        height: 15px;
      }
    }

    .btn-icon-align + .btn-icon-align {
      margin-left: 20px;
    }
  }
}



i.mdi:first-child {
  margin-right: 0;
}

i.mdi:nth-child(2) {
  margin-left: 0;
}

i.mdi {
  font-size: 28px;

  margin-left: 3px;
  margin-right: 3px;
}

i[class^="ct-icon-"] {
  font-size: 22px;

  margin-left: 3px;
  margin-right: 3px;
}

.btn-dashed-choose {
  font-family: 'Lato', sans-serif !important;
  font-size: 14px !important;
  text-align: left;
  color: #656565 !important;

  height: 47px;

  background: #FAFBFC;
  border: 1px dashed #B0BFCE;
  border-radius: 3px;

  position: relative;

  &:hover, &.active {
    border-color: #0080FC;
  }

  i {
    right: 0;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/editor/apps/Forms/MultiStepForm/ConfigModals.vue